/* src/app/shared/components/event-list/event-item/event-item.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.event-item {
  background-color: white;
  font-size: 1rem;
}
.event-item a {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  padding: 1.0625em 1.375em 0.8125em;
  margin: 0 0 0.25em 0;
  border-top: solid thin #e8e8e6;
  border-bottom: solid thin #e8e8e6;
  color: currentColor;
  text-decoration: none;
}
.event-item a:hover {
  background-color: #f0f0ef;
}
.event-item a .event-content {
  line-height: 1.35;
}
.event-item a .event-content .date-range {
  font-size: 0.6875em;
  color: rgba(36, 36, 36, 0.87);
}
.event-item a .event-content .event-title,
.event-item a .event-content .event-booth {
  font-size: 0.8125em;
  font-weight: 700;
  color: #101010;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.event-item a .event-content .event-location {
  font-size: 0.8125em;
  color: #817b7b;
}
/*# sourceMappingURL=event-item.component.css.map */
